import React from 'react';
import ReactDOM from 'react-dom';
import styles from './LogoutOverlay.module.scss';

const LogoutOverlay = () =>
  ReactDOM.createPortal(
    <div className={styles.overlay}>
      <div className={styles.content}>
        <div className={styles.spinner} />
        <p className={styles.text}>Signing you out...</p>
      </div>
    </div>,
    document.body,
  );

export default LogoutOverlay;
